import { Box } from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom';
import { resourceName } from './settings';
import { useSave } from './service';
import { FormValues } from './model';
import { Form } from './Form';
import ContainerLayout from '@/components/Layout/ContainerLayout';
import HeaderLayout from '@/components/Layout/HeaderLayout';

export function PermissaoFiliaisCreate() {
  const navigate = useNavigate();
  const { mutateAsync } = useSave();

  async function handleSave(values: FormValues) {
    try {
      const response = await mutateAsync(values);
      navigate(`${response.data.idconexao}`);
    } catch (e) { }
  }

  return (
    <ContainerLayout>
      <HeaderLayout
        breadcrumbActived
        title={resourceName}
      />
      <Box p={5}>
        <Form handleSave={handleSave} />
      </Box>
    </ContainerLayout>
  );
}
